import { AfterViewInit, Component, ElementRef, inject, Injector, Input, Optional, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { CaseService } from '../../_types/case-service';
import { Capability } from 'src/app/modules/common/_types/capability';
import { CasesServicesService } from '../../_services/cases-services.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { firstValueFrom, map, zip } from 'rxjs';
import { CapabilitiesService } from 'src/app/modules/common/_services/capabilities.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { ConfigurationsService } from '../../../common/_services/configurations.service';
import { Filter, FilterOperation, NotFilter, OrFilter } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { MaterialsService } from 'src/app/modules/materials/_services/materials.service';
import { CaseServiceMaterial } from '../../_types/case-service-material';
import { Worker } from 'src/app/modules/workers/_types/worker';
import { VehiclesTypesService } from 'src/app/modules/vehicles-types/_services/vehicles-types.service';
import { VehicleType } from 'src/app/modules/vehicles-types/_types/vehicle-type';
import { EquipmentsService } from 'src/app/modules/equipments/_services/equipments.service';
import { Equipment } from 'src/app/modules/equipments/_types/equipment';
import moment from 'moment';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { WorkersCalendarsEventsService } from 'src/app/modules/workers/_services/workers-calendars-events.service';
import { WorkerCalendarEvent } from 'src/app/modules/workers/_types/worker-calendar-event';
import { CaseServiceDetailComponent } from './case-service-detail/case-service-detail.component';
import { WorkersTimeRangesService } from 'src/app/modules/workers/_services/workers-time-ranges.service';
import { WorkerTimeRange } from 'src/app/modules/workers/_types/worker-time-range';
import { GuardsShiftsDatesService } from 'src/app/modules/guards-shifts/_services/guards-shifts-dates.service';
import { GuardShiftDate } from 'src/app/modules/guards-shifts/_types/guard-shift-date';
import { GuardShift } from 'src/app/modules/guards-shifts/_types/guard-shift';
import { WorkersService } from 'src/app/modules/workers/_services/workers.service';
import { IParamsResource } from 'src/app/core/jsonapi/interfaces/params-resource';
import { CasesService } from '../../_services/cases.service';
import { Case } from '../../_types/case';
import { AffectedsService } from '../../_services/affecteds.service';
import { CasesServicesReasonsService } from '../../_services/cases-services-reasons.service';
import { CaseServiceReason } from '../../_types/case-service-reason';
import { LocalStorageService } from 'angular-web-storage';
import { LoginService } from 'src/app/modules/login/login.service';
import { ContractWorker } from 'src/app/modules/companies/_types/contract-worker';
import { ContractWorkersService } from 'src/app/modules/companies/_services/contracts-workers.service';
import { Transaction } from 'src/app/modules/transactions/_types/transaction';
import { TransactionsService } from 'src/app/modules/transactions/_services/transactions.service';
import { ThisReceiver, UnaryOperator } from '@angular/compiler';
import { LocationUtilsService } from 'src/app/core/services/location-utils.service';
import { GoogleMap, MapMarkerClusterer, MapDirectionsResponse, MapDirectionsService, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { CasesStatesService } from '../../_services/cases-states.service';
import { CaseState } from '../../_types/case-state';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ComunicationsComponent } from 'src/app/modules/comunications/communications/comunications.component';
import { PhoneService } from 'src/app/modules/phone/_services/phone.service';
import { CountriesRegionsService } from 'src/app/modules/common/_services/countries-regions.service';
import { ZonesService } from 'src/app/modules/zones/_services/zones.service';
import { ZonesLinesService } from 'src/app/modules/zones/_services/zones-lines.service';
import { AddressesService } from 'src/app/modules/common/_services/addresses.service';
import { Address } from 'src/app/modules/common/_types/address';
import { ContractCapabilitiesService } from 'src/app/modules/companies/_services/contracts-capabilities.service';
import { CasesServicesCausesService } from '../../_services/cases-services-causes.service';
import { ServicesTypesCompaniesService } from 'src/app/modules/services-types/_services/services-types-companies.service';
import { CasesServicesTypesService } from '../../_services/cases-services-types.service';
import { Affected, affectedPartyTypeLabel } from '../../_types/affected';
import { CalendarsEventsService } from 'src/app/modules/calendars/_services/calendars-events.service';
import { CalendarEvent } from 'src/app/modules/calendars/_types/calendar-event';
import { CountriesCitiesService } from 'src/app/modules/common/_services/countries-cities.service';
import { CasesNotificationsNumbersService } from '../../_services/cases-notifications-numbers.service';
import { CaseNotificationNumber } from '../../_types/case-notification-number';
import { WorkerZonesService } from 'src/app/modules/workers/_services/workers-zones.service';
import { WorkerZone } from 'src/app/modules/workers/_types/worker-zone';
import { StringUtilsService } from 'src/app/core/services/string-utils.service';

@Component({
    selector: 'app-service',
    templateUrl: './service.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./service.component.scss'],
    standalone: false
})
export class CasesDetailServiceComponent implements AfterViewInit {

  private injector = inject(Injector);

  public allWorkers: Worker[] = [];
  public workersDistance:any = {};
  public filterByWorkerId:string|null = null;

  public caseServiceFormGroup!: RxFormGroup;
  private onCasesSearchFilterTimeout: any;
  public cases:Case[] = [];
  public pendingCases:Case[] = [];
  public casesStates:CaseState[] = [];
  public selectedCaseStateId?: string;
  public case: Case = new Case();
  public service: CaseService = new CaseService();
  public capabilities: Capability[] = [];
  public vehiclesTypes: VehicleType[] = [];
  public equipments: Equipment[] = [];
  public duration: number = 1;
  public date: Date | null = null;
  public startWeekDate: Date | null = null;
  public endWeekDate: Date | null = null;
  public startDateMap: Date = new Date();
  public endDateMap: Date = this.startDateMap; //moment(this.startDateMap).add(7, 'day').toDate();
  public includeGuardShift: boolean = false;
  public durationOptions: any[] = [];
  public selectedCapability: string | null = null;
  public selectedVehicleType: string = '';
  public selectedEquipment: string = '';
  public materials: any[] = [];
  public selectedMaterials: string[] = [];
  public allowMaterials: boolean = false;
  
  public zipCode: string = '';
  public zipCodeGuard: string = '';

  public availableWorkers: Worker[] = [];
  public comboWorkers: Worker[] = [];
  public workerCalendarEvents: WorkerCalendarEvent[] = [];
  public workerCalendarEventsWidth: any = {};
  public workerTimeRanges: WorkerTimeRange[] = [];
  public casesServices: CaseService[] = [];
  public caseServicesDistances: any = {};

  public infoSelectedWorker!: Worker | null;
  public selectedWorker!: Worker | null;
  public selectedTimeSlot: any;

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public overCaseService: CaseService | null = null;
  public guardShifts: GuardShift[] = [];
  public calendarEvents: CalendarEvent[] = [];
  public calendarEventsMessage: string = '';

  public timeSlots: any[] = [];

  public createServiceDialogVisible: boolean = false;
  public hoursPredefinedCaseService: number = 2;
  public minDate: Date = new Date();

  public targetId: any;
  public targets: any[] = [];
  public reclamationTypes: any[] = [
    { label: 'No', value: null },
    { label: 'Reclamación propia', value: 'Itself' },
    { label: 'Reclamación externa', value: 'External' }
  ];

  public isFirstService: boolean = false;
  public showDelayedServiceModal: boolean = false;
    public delayedServiceCauses: any = [];

  public delayedServiceReasons: any = [];
  public delayedCaseServiceReason: CaseServiceReason = new CaseServiceReason();
  public caseService: CaseService = new CaseService();

  private contractPreferedWorkers: ContractWorker[] = [];

  public previousDateInit: Date | null = null;

  private dynamicDialogRef?: DynamicDialogRef | null;
  private config?:DynamicDialogConfig | null;

  public showCaseSelector:boolean = false;
  public selectedCaseId:string|null = null;
  public listAcceptedTransactions: Transaction[] = [];
  public budgetRelated?: Transaction;


  public countriesRegions: any[] = [];
  public selectedCountryRegionId:string|null = null;
  public zones: any[] = [];
  public selectedZoneId:string|null = null;

  //public showCases:boolean = true;
  public showAllWorkers:boolean = false;
  public onlyUrgentCases:boolean = true;
  public mapWorkersCount:number = 0;
  public mapCaseCount:number = 0;
  public mapCaseUrgentCount:number = 0;
  public mapServicesNotConfirmedCount:number = 0;
  public mapServicesPendingCount:number = 0;
  public mapServicesInHouseCount:number = 0;
  public mapServicesFinalizedCount:number = 0;

  public invalidDates:boolean = false;

  public activeIndex: number = 0;
  public contractCapabilityNotFound: boolean = false;
  public workerPendingConfirm:any = {};

  public workerZones:WorkerZone[] = [];
  public caseZoneIds:string[] = [];
  public workersZonesAvailable:any[] = [];

  //panel de info de operario
  @ViewChild('workerOverlayPanel') public workerOverlayPanel?:OverlayPanel;

  @ViewChildren('autoGrowTextarea') autoGrowTextareas!: QueryList<ElementRef<HTMLTextAreaElement>>;

  //panel de opciones de telefono
  @ViewChild('phoneOverlayPanel') public phoneOverlayPanel?:OverlayPanel;
  public phoneOverlayPanelData:any = {
    phoneNumber: null
  }

  //mapa
  private finalMarkers:any[] = [];
  public markerClustererImagePath = 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m';
  public mapOptions: google.maps.MapOptions = {
    mapId: 'planification-map'
  };
  @ViewChild(GoogleMap) googleMap!: GoogleMap;
  @ViewChild(MapInfoWindow) infoWindow!: MapInfoWindow;
  public directionsResults: google.maps.DirectionsResult | undefined;
  public markers: any[] = [];
  public selectedMarker: MapMarker | null = null;
  public selectedMarkerData:any = null;
  public markerTimeSlots: any[] = [];
  public center: google.maps.LatLng = new google.maps.LatLng(40.4166400, -3.7032700);
  public zoom = 13;
  public routeStartAddress:Address|null = null;
  public routeCaseServices:CaseService[] = [];
  public isNotAllowed:boolean = false;
  public isNotAllowedReason:string = '';
  public servicesTypes: any[] = [];
  public distanceToCityCenter?:number;
  public totalAffecteds: Affected[] = [];
  public showCheckIfIsGuard: boolean = false;
  public showSinCitarCheck: boolean = false;
  public caseNotificationNumbers:CaseNotificationNumber[] = [];

  public notificationNumberId: string | null = null;
  public selectSomething: boolean = false;
  public showMessageNotes: boolean = false;

  constructor(
    private addressesService: AddressesService,
    private phoneService: PhoneService,
    private loginService:LoginService,
    private materialsService: MaterialsService,
    private storage: LocalStorageService,
    private formBuilder: RxFormBuilder,
    private casesService: CasesService,
    private casesStatesService: CasesStatesService,
    private casesServicesService: CasesServicesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private capabilitiesService: CapabilitiesService,
    private workersService: WorkersService,
    private vehiclesTypesService: VehiclesTypesService,
    private equipmentsService: EquipmentsService,
    private guardsShiftsDatesService: GuardsShiftsDatesService,
    private workersCalendarsEventsService: WorkersCalendarsEventsService,
    private dialogService: DialogService,
    private workerTimeRangesService: WorkersTimeRangesService,
    private affectedsService: AffectedsService,
    private casesServicesReasonsService: CasesServicesReasonsService,
    private contractWorkersService: ContractWorkersService,
    private transactionService: TransactionsService,
    private locationUtilsService:LocationUtilsService,
    private mapDirectionsService: MapDirectionsService,
    private countriesRegionsService: CountriesRegionsService,
    private countriesCitiesService: CountriesCitiesService,
    private zonesService: ZonesService,
    private zonesLinesService: ZonesLinesService,
    private contractCapabilityService: ContractCapabilitiesService,
    private casesServicesCausesService: CasesServicesCausesService,
    private servicesTypesCompanyService: ServicesTypesCompaniesService,
    private caseServiceTypesService: CasesServicesTypesService,
    private calendarEventsService: CalendarsEventsService,
    private caseNotificationsNumbersService: CasesNotificationsNumbersService,
    private workersZonesService: WorkerZonesService,
    private configurationsService: ConfigurationsService,
    public stringUtilsService: StringUtilsService
  ) {
    this.caseServiceFormGroup = this.formBuilder.formGroup<CaseService>(this.service) as RxFormGroup;
    this.config = this.injector.get(DynamicDialogConfig, null);
    this.dynamicDialogRef = this.injector.get(DynamicDialogRef, null);
  }

  async ngOnInit() {

    this.allowWrite = this.loginService.hasPermission("CASES_SERVICES.WRITE");
    this.allowDelete = this.loginService.hasPermission("CASES_SERVICES.DELETE");
    this.allowMaterials = this.loginService.hasPermission("CASES_SERVICES.MATERIALS");

    this.date = new Date();
    this.startWeekDate = moment(this.date).startOf('week').toDate();
    this.endWeekDate = moment(this.date).endOf('week').toDate();
    let caseId = this.config?.data.caseId;
    if(caseId){
      this.service.caseId = this.config?.data.caseId;
      await this.loadCase(caseId);

      //centramos el mapa en el expediente
      if(this.case.address!=null && this.case.address.latitude!=null && this.case.address.longitude!=null) {
        this.center = new google.maps.LatLng(this.case.address.latitude, this.case.address.longitude);
      }

    }else{
      this.showCaseSelector = true;
    }
    let serviceId = this.config?.data.serviceId;
    if (serviceId) {
      await this.loadService(serviceId);
    }
    await this.loadWorkerTimeRanges();
    await this.loadCalendarEvents();
    this.loadCaseStates();
    this.loadDurations();
    this.loadVehicleTypes();
    this.loadEquipments();
    if (this.allowMaterials) this.loadMaterials();
    await this.loadGuardShifts();
    this.loadAllWorkers();
    await this.loadCaseServices();
    await this.loadCaseServicesPending();
    this.loadWorkerZones();
    this.scheduleResizeTextareas();
    this.loadCapabilities();
    this.loadSinCitarConfiguration();
  }

  //el check "Sin citar" solo se ofrece en los tenants que lo tengan activado
  async loadSinCitarConfiguration() {
    let filters = {
      code: new Filter(FilterOperation.equals, 'code', '', 'SIN_CITAR')
    };
    let params: IParamsCollection = {
      page: { size: 1 },
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.configurationsService.all(params));
    this.showSinCitarCheck = response.meta['total'] > 0 && response.data[0].value == 'true';
  }

  ngAfterViewInit(): void {
    this.autoGrowTextareas.changes.subscribe(() => this.scheduleResizeTextareas());
    this.scheduleResizeTextareas();
  }

  async loadCountriesRegions() {
    let params: IParamsCollection = {
      page: { size: 1000 },
      sort: ['name']
    };
    let response = await firstValueFrom(this.countriesRegionsService.all(params));
    this.countriesRegions = response.data;
  }

  onCountryRegionChange($event:any){
    //this.selectedCountryRegionId = $event.value;
    this.loadZones();
    this.centerMapToSelectedCountryRegionState();
  }

  async centerMapToSelectedCountryRegionState(){
    if(this.selectedCountryRegionId){
      let countryRegion = this.countriesRegions.find(m => m.id == this.selectedCountryRegionId);
      if(countryRegion){
        //cargamos ciudad principal
        let filter : any = {
          name: new Filter(FilterOperation.equals, 'name', '', countryRegion.principalCity),
        };
        let params: IParamsCollection = {
          filter: FilterBuilder.fromObject(filter).build()
        };
        let principalCities = await firstValueFrom(this.countriesCitiesService.all(params));
        if(principalCities.data.length > 0){
          if(principalCities.data[0].latitude && principalCities.data[0].longitude){
            this.center = new google.maps.LatLng(principalCities.data[0].latitude, principalCities.data[0].longitude);
            this.zoom = 12;
          }
        }
      }
    }
  }

  async loadZones() {
    let filters:any = {
      countryRegionId: new Filter(FilterOperation.equals, 'countryRegionId', '', this.selectedCountryRegionId)
    };
    let params: IParamsCollection = {
      page: { size: 1000 },
      sort: ['name'],
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.zonesService.all(params));
    this.zones = response.data;
  }  

  async generateTimeSlots() {
    this.timeSlots = [];

    //dia elegido
    let date = this.date;

    //si es semanal, el dia elegido es el lunes de la semana
    if(this.activeIndex==1 && this.startWeekDate) date = this.startWeekDate;

    //timeslot para por confirmar
    this.timeSlots.push({
      label: 'Por confirmar',
      confirmed: false,
      guard: false,
      date: moment(date).startOf('day').toDate(),
      hour: 0,
      minute: 0
    });

    //all time slot
    let allHourStart = 0;
    let allHourEnd = 23;

    //horario normal
    let normalHourStart = 8;
    let normalHourEnd = 19;

    //geenramos slots
    let hourStart = normalHourStart;
    let hourEnd = normalHourEnd;
    if (this.includeGuardShift) {
      hourStart = allHourStart;
      hourEnd = allHourEnd;
    }
    for (let i = hourStart; i <= hourEnd; i++) {
      let guard = i < normalHourStart || i >= normalHourEnd;
      this.timeSlots.push({
        label: i + ':00',
        confirmed: true,
        guard: guard,
        date: moment(date).set({ hour: i, minute: 0 }).toDate(),
        hour: i,
        minute: 0
      });
      this.timeSlots.push({
        label: i + ':30',
        confirmed: true,
        guard: guard,
        date: moment(date).set({ hour: i, minute: 30 }).toDate(),
        hour: i,
        minute: 30
      });
    }
  }

  async onCaseSelect(){
    this.service.caseId = this.selectedCaseId!;
    this.loadCase(this.selectedCaseId!);
  }

  async loadCase(caseId: string) {
    let params: IParamsResource = {
      include:  ['company', 'client', 'processor', 'address', 'caseState', 'caseType', 'contract.business', 'clientPolicy.insuranceCompany', 'caseTreatment']
      
    };
    this.case = await firstValueFrom(this.casesService.get(caseId, params));
    this.loadCaseNotificationsNumbers();

    this.targets = [];

    if (this.case.client) {
      this.case.client.name = this.case.client.name + ' (Asegurado)';
      this.targets.push(this.case.client);
      this.targetId = this.case.client.id;
    }

    //calculamos la distancia al centro de la ciudad
    this.distanceToCityCenter = await firstValueFrom(this.casesService.distanceToCityCenter(this.case.id!));
    this.loadServicesTypes();

    if (this.case.isUrgent) {
      //Buscamos si es el primer servicio
      let params: IParamsCollection = {
        page: { size: 1 }

      }
      let filters: any = {
        caseId: new Filter(FilterOperation.equals, 'caseId', '', this.case.id),
        isCancelled: new Filter(FilterOperation.equals, 'isCancelled', '', false)
      };
      params.filter = FilterBuilder.fromObject(filters).build();
      let caseService = await firstValueFrom(this.casesServicesService.all(params));
      if (caseService.data.length == 0) {
        this.service.isUrgent = true;
        this.isFirstService = true;
      }

    }

    await this.loadAffecteds();
    await this.loadContractPreferentWorkers();
    await this.loadCaseZones();
  }

  async loadCaseZones(){
    if(this.case.address?.zipCode==null) return;
    let filter: any = {
      postalCode: new Filter(FilterOperation.equals, "value", '', this.case.address?.zipCode)
    };
    let params:IParamsCollection = {
      page: { size: 1000 },
      filter: FilterBuilder.fromObject(filter).build()
    };
    var response = await firstValueFrom(this.zonesLinesService.all(params));
    this.caseZoneIds = response.data.map(m=>m.zoneId);
  }

  async loadCaseNotificationsNumbers() {
    let filter : any = {
      caseId: new Filter(FilterOperation.equals, "caseId", '', this.case.id)
    };
    let params:IParamsCollection = {
      page: { size: 50 },
      sort: ['date'],
      filter: FilterBuilder.fromObject(filter).build()
    };
    let response = await firstValueFrom(this.caseNotificationsNumbersService.all(params));
    this.caseNotificationNumbers = response.data;

    if(this.caseNotificationNumbers.length == 1){
      this.service.caseNotificationNumberId = this.caseNotificationNumbers[0].id as string;
    }
  }


  async loadService(serviceId: string) {
    this.service = await firstValueFrom(this.casesServicesService.get(serviceId));
    this.previousDateInit = this.service.date;
    this.scheduleResizeTextareas();
  }

  async loadCaseStates() {
    let params: IParamsCollection = {
      sort: ['name']
    };
    let response = await firstValueFrom(this.casesStatesService.all(params));
    this.casesStates = response.data;
    this.selectedCaseStateId = this.casesStates.find(m => m.code == 'ASSIGNMENT_PENDING')?.id;
  }

  async loadCapabilities() {
    let response = await firstValueFrom(this.capabilitiesService.all());
    this.capabilities = response.data;

    this.selectedCapability = this.config?.data.selectedCapability ?? null;
    if(this.selectedCapability) {
      await this.getAvailability();      
      setTimeout(() => {     
        this.onSelectDate(); 
        this.generateTimeSlots();
      }, 500);
    }
  }

  async loadVehicleTypes() {
    let response = await firstValueFrom(this.vehiclesTypesService.all());
    this.vehiclesTypes = response.data;
  }

  async loadEquipments() {
    let response = await firstValueFrom(this.equipmentsService.all());
    this.equipments = response.data;
  }

  async loadMaterials() {
    let params: IParamsCollection = {
      sort: ['name'],
      page: { size: 0 },
      filter: FilterBuilder.fromObject({
        active: new Filter(FilterOperation.equals, 'active', '', true)
      }).build()
    };
    let response = await firstValueFrom(this.materialsService.all(params));
    this.materials = response.data;
  }

  async openInfoWindow(marker: MapMarker, data: any) {
    this.directionsResults = undefined;
    this.selectedMarker = marker;
    this.selectedMarkerData = data;
    this.infoWindow.options = { 
      headerDisabled: true,
    };
    this.markerTimeSlots = this.getTimeSlotForMarker(data);
    this.infoWindow.open(marker);
  }

  async closeInfoWindow(){
    if(this.infoWindow) this.infoWindow.close();
  }

  getWorker(workerId: string): Worker | null {
    return this.allWorkers.find(m => m.id == workerId) ?? null;
  }

  setInfoSelectedWorker($event:any, worker:Worker){
    this.infoSelectedWorker = worker;
    if(this.workerOverlayPanel?.overlayVisible){
      this.workerOverlayPanel.hideTransitionOptions = "0ms ease-out";
      this.workerOverlayPanel?.hide();
      setTimeout(() => {
        this.workerOverlayPanel?.show($event);
      }, 250);
    }else{
      this.workerOverlayPanel?.show($event);
    }
  }

  async loadCalendarEvents() {
    /*let filter = {
      date: new Filter(FilterOperation.equals, 'date', '', moment(this.date).startOf('day').toDate().toISOString())
    };*/
    let startOfDayDate = moment(this.date).startOf('day');
    let endOfDayDate = moment(this.date).endOf('day');

    if(this.activeIndex == 1){
      //Estamos en selección de semana.
      startOfDayDate = moment(this.startWeekDate).startOf('day');
      endOfDayDate = moment(this.endWeekDate).endOf('day');
    }

    let filter: { fromDate: Filter; toDate: Filter; calendarId?: Filter } = {
      fromDate: new Filter(FilterOperation.greaterOrEqual, 'date', '', startOfDayDate.toISOString()),
      toDate: new Filter(FilterOperation.lessOrEqual, 'date', '', endOfDayDate.toISOString()),
    };

    //dentro de un expediente, solo cargamos los festivos de los calendarios de
    //los operarios que pueden trabajar en el (no los de todos los calendarios)
    if(this.case?.id){
      let calendarIds = [...new Set(this.availableWorkers.map(w => w.calendarId).filter(id => id != null))];
      if(calendarIds.length == 0){
        //aun no se han calculado los operarios disponibles: no cargamos todos
        this.calendarEvents = [];
        this.calendarEventsMessage = '';
        return;
      }
      filter.calendarId = new Filter(FilterOperation.any, 'calendarId', '', calendarIds);
    }

    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject(filter).build(),
      include: ['scope', 'calendar']
    };
    let response = await firstValueFrom(this.calendarEventsService.all(params));
    this.calendarEvents = response.data;
    this.calendarEventsMessage = this.buildCalendarEventsMessage();
  }

  // Construye el texto del aviso de festivos de la cita: el nacional se muestra
  // una sola vez ("Festivo nacional"); el resto, por calendario ("Festivo Local
  // en Almería"); los eventos sin ámbito, "Festivo en {calendario}".
  private buildCalendarEventsMessage(): string {
    let parts: string[] = [];

    let hasNational = this.calendarEvents.some(e => e.scope?.code === 'NACIONAL');
    if (hasNational) {
      parts.push('Festivo nacional');
    }

    for (let event of this.calendarEvents) {
      if (event.scope?.code === 'NACIONAL') continue;

      let calendarName = event.calendar?.name ?? '';
      if (event.scope?.name) {
        parts.push('Festivo ' + event.scope.name + (calendarName ? ' en ' + calendarName : ''));
      } else {
        parts.push('Festivo' + (calendarName ? ' en ' + calendarName : ''));
      }
    }

    return parts.join(', ');
  }

  async loadGuardShifts() {
    let filter = {
      date: new Filter(FilterOperation.equals, 'date', '', moment(this.date).startOf('day').toDate().toISOString())
    };
    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject(filter).build(),
      include: ['guardShift']
    };
    let response = await firstValueFrom(this.guardsShiftsDatesService.all(params));
    let tempGuardShift: GuardShift[] = [];
    response.data.forEach((item: GuardShiftDate) => {
      if (tempGuardShift.find(m => m.id == item.guardShift.id) == null) {
        tempGuardShift.push(item.guardShift);
      }
    });
    this.guardShifts = tempGuardShift;
  }

  async loadAffecteds() {
    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject({ caseId: new Filter(FilterOperation.equals, "caseId", "", this.case.id) }).build()
    }
    let response = await firstValueFrom(this.affectedsService.all(params));
    this.targets = [
      ...this.targets,
      ...response.data.map(affected => ({
        ...affected,
        name: affected.name + " (" + affectedPartyTypeLabel(affected.partyType) + ")"
      }))
    ];
    this.totalAffecteds = this.targets.filter((a: Affected) => a.type != "clients");
  }

  async loadContractPreferentWorkers() {
    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject({ contractId: new Filter(FilterOperation.equals, "contractId", "", this.case.contractId) }).build()
    }
    let response = await firstValueFrom(this.contractWorkersService.all(params));
    this.contractPreferedWorkers = response.data
  }

  async getSelectedZoneZipCodes():Promise<string[]>{
    let zipCodes:string[] = [];
    if(this.selectedZoneId!=null){
      let params:IParamsCollection = {
        filter: FilterBuilder.fromObject({ zoneId: new Filter(FilterOperation.equals, 'zoneId', '', this.selectedZoneId) }).build()
      }
      let response = await firstValueFrom(this.zonesLinesService.all(params));
      response.data.forEach((item:any) => {
        if(zipCodes.indexOf(item.value)==-1) zipCodes.push(item.value);
      });
    }
    return zipCodes;
  }

  
  async loadCaseServicesPending() {
    //obtenemos codigos postales de la zona elegida
    let zipCodes:any[] = await this.getSelectedZoneZipCodes();
    let filters = {
      isCancelled: new Filter(FilterOperation.equals, 'isCancelled', '', 'false'),
      isConfirmed: new Filter(FilterOperation.equals, 'isConfirmed', '', 'false'),
      manageYourAppointments: new Filter(FilterOperation.equals, 'worker.manageYourAppointments', '', 'true'),
    };
    let params: IParamsCollection = {
      page: { size: 10000 },
      filter: FilterBuilder.fromObject(filters).build(),
      fields: {
        caseServices: 'workerId'
      }
    };
    let response = await firstValueFrom(this.casesServicesService.all(params));

    //calcular ancho de los servicios y distancia con el expediente a citar
    this.workerPendingConfirm = {};
    var workersWithPendingCasesServicesToConfirm = response.data.map(m=>m.workerId).filter((value, index, self) => self.indexOf(value) === index);
    
    workersWithPendingCasesServicesToConfirm.forEach((workerId: any) => {      
      this.workerPendingConfirm['guid_' + workerId] = response.data.filter((m : any) => m.workerId == workerId).length;
    });
  }

  async loadCaseServices() {
    this.clearWorkerTimeSlot();
    
    //si es vista de diario
    let startDate = moment(this.date).startOf('day');
    let endDate = moment(this.date).endOf('day');
    
    //si es vista de semana
    if(this.activeIndex==1){
      startDate = moment(this.startWeekDate).startOf('day');
      endDate = moment(this.endWeekDate).endOf('day');
    }else if(this.activeIndex==2){
      startDate = moment(this.startDateMap).startOf('day');
      endDate = moment(this.endDateMap).endOf('day');
    }

    //obtenemos codigos postales de la zona elegida
    let zipCodes:any[] = await this.getSelectedZoneZipCodes();
    let filters: {
      date1: OrFilter;
      date2: Filter;
      isCancelled: Filter;
      countryRegionId: Filter;
      zoneId: Filter;
      workerId?: Filter;
    } = {
      //empieza dentro del rango o empezo antes pero sigue ocupandolo (servicios de varios dias)
      date1: new OrFilter([
        new Filter(FilterOperation.greaterOrEqual, 'date', '', startDate.toISOString()),
        new Filter(FilterOperation.greaterOrEqual, 'estimatedDateEnd', '', startDate.toISOString())
      ]),
      date2: new Filter(FilterOperation.lessThan, 'date', '', endDate.toISOString()),
      isCancelled: new Filter(FilterOperation.equals, 'isCancelled', '', 'false'),
      countryRegionId: new Filter(FilterOperation.equals, 'case.address.countryRegionId', '', this.selectedCountryRegionId),
      zoneId: new Filter(FilterOperation.any, 'case.address.zipCode', '', zipCodes.length>0?zipCodes:null),
      workerId: new Filter(FilterOperation.equals, 'workerId', '', this.filterByWorkerId)
    };
    
    if(this.activeIndex == 2){
      //vista de mapa eliminamos el filtro por operario
      if(filters.workerId) delete filters.workerId;
    }
    let params: IParamsCollection = {
      include: ['case', 'case.client', 'case.address', 'case.processor', 'capability', 'materials.material'],
      sort: ['date'],
      page: { size: 1000 },
      filter: FilterBuilder.fromObject(filters).build(),
      fields: {
        cases: 'caseNumber,description,isUrgent,address,client,processor',
        capabilities: 'name',
        clients: 'name,phone1,phone2',
        addresses: 'latitude,longitude,fullAddress,addressLine1,addressLine2,zipCode,city,countryCode,countryRegionId',
        users: 'name,absence',
        caseServices: 'workerId,date,dateEnd,estimatedDateEnd,notes,isUrgent,isNotScheduled,isConfirmed,notModify,capabilityId,capability,caseId,case,materials',
        caseServiceMaterials: 'materialId,material',
        materials: 'name,iconClass',
      }
    };
    let response = await firstValueFrom(this.casesServicesService.all(params));

    //calcular distancia con el expediente a citar (el alto se calcula por slot en getCaseServiceHeight)
    response.data.forEach((service: CaseService) => {
      //calculamos la distancia
      //si estamos planificando un expediente, debe calcular respecto al expediente siempre
      //si estamos en planificacion genral, debemos calcular respecto al servicio anterior
      //el bloque comentado no parece tener sentido, siempre debe ser respecto al servicio anterior o a la salida del operario
      let caseAddress = this.case?.address;
      if(caseAddress!=null && service.case?.address!=null){
        //si tenemos servicio de expediente, se calcula respecto a el
        this.caseServicesDistances['guid_' + service.id] = this.locationUtilsService.distance(caseAddress.latitude!, caseAddress.longitude!, service.case?.address.latitude!, service.case?.address.longitude!, 'K');
      }else{
        //si no tenemos expediente de referencia, se hace respecto al servicio anterior o respecto a salida de operario

        //busamos el servicio anterior del mismo operario
        let distance = null;
        let previousService = response.data.find(m=>m.workerId == service.workerId && m.date < service.date);
        if(previousService!=null && previousService.case?.address!=null && service.case?.address!=null && previousService.case?.address.latitude!=null && previousService.case?.address.longitude!=null && service.case?.address.latitude!=null && service.case?.address.longitude!=null){
          //si hay servicio anterior, calculamos la distancia
          distance = this.locationUtilsService.distance(previousService.case?.address.latitude!, previousService.case?.address.longitude!, service.case?.address.latitude!, service.case?.address.longitude!, 'K');
        }else{
          //si no hay servicio anterior, calculamos la distancia respecto a la salida del operario
          let worker = this.allWorkers.find(m=>m.id == service.workerId);
          if(worker!=null){
            if(worker.usePrincipalAddressAsWorkStart && worker.address!=null && worker.address.latitude!=null && worker.address.longitude!=null && service.case?.address!=null && service.case?.address.latitude!=null && service.case?.address.longitude!=null){
              distance = this.locationUtilsService.distance(worker.address?.latitude!, worker.address?.longitude!, service.case?.address.latitude!, service.case?.address.longitude!, 'K');
            }else if(worker.workStartAddress!=null && worker.workStartAddress.latitude!=null && worker.workStartAddress.longitude!=null && service.case?.address!=null && service.case?.address.latitude!=null && service.case?.address.longitude!=null){
              distance = this.locationUtilsService.distance(worker.workStartAddress.latitude!, worker.workStartAddress.longitude!, service.case?.address.latitude!, service.case?.address.longitude!, 'K');
            }
          }
        }

        this.caseServicesDistances['guid_' + service.id] = distance;
      }

    });

    this.casesServices = response.data;

    //this.generateMarkers();
  }

  loadDurations() {
    this.durationOptions = Array.from({ length: 10 }, (v, k) => {
      return { label: k + 1 + (k == 0 ? ' hora' : ' horas'), value: k + 1 };
    });
  }

  async updateMap(){
    //this.loadAllWorkers();
    await this.onSelectDateMap();
    this.generateMarkers();
  }

  getImage(url:string):string{
    //const img = document.createElement('img');
    //img.src = new URL(location.protocol + location.host + url, import.meta.url).href;
    return url;
  }

  async generateMarkers(){
    let workersBounds = new google.maps.LatLngBounds();
    let bounds = new google.maps.LatLngBounds();

    //si habia amrkers, los quitamos del mapa
    /*this.finalMarkers.forEach(marker => {
      marker.setMap(null);
    });*/

    this.finalMarkers = [];

    //generamos los markers para los operarios
    this.mapWorkersCount = 0;
    /*let filteredWorkers = this.allWorkers.filter(m => m.id == this.filterByWorkerId || this.filterByWorkerId == null)*/
    let availableWorkers = this.getAvailableWorkers();
    let filteredWorkers = availableWorkers;
    if(this.showAllWorkers) filteredWorkers = this.allWorkers;
    filteredWorkers.forEach((worker: Worker) => {
      //no mostrarmos posicion real, si no la de salida
      let latitude = null; // worker.latitude;
      let longitude = null; // worker.longitude;
      if(latitude==null || longitude==null){
        if(worker.usePrincipalAddressAsWorkStart && worker.address!=null){
          latitude = worker.address?.latitude;
          longitude = worker.address?.longitude;
        }else if(worker.workStartAddress!=null){
          latitude = worker.workStartAddress.latitude;
          longitude = worker.workStartAddress.longitude;
        }
      }
      if(latitude!=null && longitude!=null){
        let latLng = new google.maps.LatLng(latitude, longitude);
        let marker:any = {
          position: latLng,
          icon: this.getImage('/assets/icons/marker-worker.png'),
          data: {
            case: null,
            service: null,
            worker: worker,
            scheduleAvailable: availableWorkers.find(m=>m.id == worker.id)!=null
          }
        };
        this.finalMarkers.push(marker);
        
        workersBounds.extend(latLng);
        
        this.mapWorkersCount++;
      }else{
        //console.log('No latlng for worker', worker.name);
      }
    });

    //generamos los markers para los expedientes
    this.mapCaseCount = 0;
    this.mapCaseUrgentCount = 0;
    
    //si hay expediente, añadimos el marker del expediente
    if(this.case.id!=''){
      if(this.case.address!=null && this.case.address.latitude!=null && this.case.address.longitude!=null){
        let latLng = new google.maps.LatLng(this.case.address.latitude, this.case.address.longitude);
        let icon = this.getImage('/assets/icons/marker-house.png');
        if(this.case.isUrgent){
          icon = this.getImage('/assets/icons/marker-house-urgent.png');
          this.mapCaseUrgentCount++;
        }else{
          this.mapCaseCount++;
        }
        let marker:any = {
          position: latLng,
          icon: icon,
          data: {
            case: this.case,
            service: null,
            scheduleAvailable: false
          }
        };
        this.finalMarkers.push(marker);
        bounds.extend(latLng);
      }
    }

    //generamos los markers para los servicios
    this.mapServicesNotConfirmedCount = 0;
    this.mapServicesPendingCount = 0;
    this.mapServicesInHouseCount = 0;
    this.mapServicesFinalizedCount = 0;
    this.casesServices.filter( m =>
      (m.workerId == this.filterByWorkerId || this.filterByWorkerId == null) &&
      (m.capabilityId == this.selectedCapability || this.selectedCapability == null)
    ).forEach((service: CaseService) => {
      if(service.case?.address!=null && service.case?.address.latitude!=null && service.case?.address.longitude!=null){
        let latLng = new google.maps.LatLng(service.case?.address.latitude, service.case?.address.longitude);
        let icon = this.getImage('/assets/icons/marker-icon-yellow.png');
        if(!service.isConfirmed){
          icon = this.getImage('/assets/icons/marker-icon-red.png');
          this.mapServicesNotConfirmedCount++;
        }else{
          if(service.dateEnd==null){
            if(service.dateStart!=null){
              //esta en domicilio
              icon = this.getImage('/assets/icons/marker-icon-green.png');
              this.mapServicesInHouseCount++;
            }else{
              icon = this.getImage('/assets/icons/marker-icon-yellow.png');
              this.mapServicesPendingCount++;
            }
          }else{
            icon = this.getImage('/assets/icons/marker-icon-blue.png');
            this.mapServicesFinalizedCount++;
          }
        }
        let marker:any = {
          position: latLng,
          icon: icon,
          data: {
            case: service.case,
            service: service,
            worker: (service.workerId!=null?this.getWorker(service.workerId):null),
            scheduleAvailable: availableWorkers.find(m=>m.id == service.workerId)!=null
          }
        };
        this.finalMarkers.push(marker);
        bounds.extend(latLng);
      }
    });

    //generamos los markers para los expedientes pendientes de citar
    this.pendingCases.forEach((pendingCase:Case) => {
      if(pendingCase.address!=null && pendingCase.address.latitude!=null && pendingCase.address.longitude!=null){
        let latLng = new google.maps.LatLng(pendingCase.address.latitude, pendingCase.address.longitude);
        let icon = this.getImage('/assets/icons/marker-house.png');
        if(pendingCase.isUrgent){
          icon = this.getImage('/assets/icons/marker-house-urgent.png');
          this.mapCaseUrgentCount++;
        }else{
          this.mapCaseCount++;
        }
        let marker:any = {
          position: latLng,
          icon: icon,
          data: {
            case: pendingCase,
            service: null,
            scheduleAvailable: false
          }
        };
        this.finalMarkers.push(marker);
        bounds.extend(latLng);
      }
    });

    //si no hay bounds, añadimos los operarios
    //if(bounds.isEmpty()) bounds = workersBounds;

    this.markers = this.finalMarkers;

    //si no estamos en modo expediente, centramos el mapa para los markers
    if(this.markers.length>0 && this.case.id=='' && !bounds.isEmpty()){
      //descomentar
      //this.googleMap.fitBounds(bounds);
    }
  }

  async onTabChange(event: any) {
    if(this.activeIndex==2){
      //si es mapa
      this.loadCountriesRegions();
      this.loadZones();
      //this.updateMap();
    }else{
      await this.loadCaseServices();
      await this.loadPendingCases();
    }
  }

  async loadWorkerTimeRanges() {
    this.workerTimeRanges = [];
    let params: IParamsCollection = {
      page: { size: 5000 }
    };
    let response = await firstValueFrom(this.workerTimeRangesService.all(params));
    this.workerTimeRanges = response.data;
  }

  async loadWorkersEvents() {


    this.workerCalendarEventsWidth = {};
    let startOfDayDate = moment(this.date).startOf('day');
    let endOfDayDate = moment(this.date).endOf('day');

    if(this.activeIndex == 1){
      //Estamos en selección de semana.
      startOfDayDate = moment(this.startWeekDate).startOf('day');
      endOfDayDate = moment(this.endWeekDate).endOf('day');
    }

    let filtersWorkerCalendarEvents: { fromDate: Filter; toDate: Filter; workerId?: Filter } = {
      fromDate: new Filter(FilterOperation.greaterOrEqual, 'date', '', startOfDayDate.toISOString()),
      toDate: new Filter(FilterOperation.lessOrEqual, 'date', '', endOfDayDate.toISOString()),
    };
    if(this.activeIndex == 1){
      filtersWorkerCalendarEvents.workerId = new Filter(FilterOperation.equals, 'workerId', '', this.filterByWorkerId);
    }
    let paramsWorkerCalendarEvents: IParamsCollection = {
      page: { size: 5000 },
      include: ['calendarEventType'],
      filter: FilterBuilder.fromObject(filtersWorkerCalendarEvents).build()
    };
    let response = await firstValueFrom(this.workersCalendarsEventsService.all(paramsWorkerCalendarEvents));
    //calcular ancho de los eventos
    response.data.forEach((event: WorkerCalendarEvent) => {
      let width = '100%'; //1 slot, 100%
      if (event.calendarEventType.allowTimeRange) {
        //calculamos la fecha de inicio con la hora
        let startparts = event.start.split(':');
        let endparts = event.end.split(':');
        let startDate = moment(event.date).set({ hour: startparts[0], minute: startparts[1] });
        let endDate = moment(event.date).set({ hour: endparts[0], minute: endparts[1] });
        let duration = moment.duration(endDate.diff(startDate));
        //width = 'calc(' + (hours * 2 * 100)+ '% + ' + ((hours * 2)-1) + 'px)'; //un 100% es 30 minutos, sumamos 2px por cada bloque por el border
        width = '100%';
        event.date = startDate.toDate();
      } else {
        //dia completo
        //width = 'calc(' + (this.timeSlots.length * 100) + '% + ' + (this.timeSlots.length-1) + 'px)'; //un 100% es 1 slot, sumamos 2px por cada slot por el border
        width = '100%';
      }
      this.workerCalendarEventsWidth['guid_' + event.id] = width;
    });
    this.workerCalendarEvents = response.data;
  }


  async loadAcceptedBudget() {
    let paramsTransactions: IParamsCollection = { 
      include: ['transactionState'],
    };

    let filtersTra = {
      caseId: new Filter(FilterOperation.any, "caseId", '', this.case.id ),
      transactionTypeId: new Filter(FilterOperation.equals, 'transactionType.code', '', 'ingoing_budget_worker'),
      transactionStateId: new Filter(FilterOperation.equals, 'transactionState.code', '', 'accepted'),
      thirdPartyId: new Filter(FilterOperation.equals, 'thirdPartyId', '', this.selectedWorker?.id) 
    }
    paramsTransactions.filter = FilterBuilder.fromObject(filtersTra).build();
    let isBudgetRequiredCaseServices2 = await firstValueFrom(this.transactionService.all(paramsTransactions));
    this.listAcceptedTransactions = isBudgetRequiredCaseServices2.data;
  }

  loadTransactionData(event: any){
    this.budgetRelated = this.listAcceptedTransactions.filter(m=>m.id == event.value)[0];
  }

  async onSelectCapability(tab:string){
    //comprobamos si la especialidad esta en compañia/contrato
    let filters: any = {
      contractId: new Filter(FilterOperation.equals, 'contractId', '', this.case.contractId),
      capabilityId: new Filter(FilterOperation.equals, 'capabilityId', '', this.selectedCapability)
    };
    if(this.includeGuardShift){
      //requiere horario guardia
      filters.guardServiceAllowed = new Filter(FilterOperation.equals, 'guardServiceAllowed', '', true);
    }else{
      //requiere filtro normal
      filters.normalServiceAllowed = new Filter(FilterOperation.equals, 'normalServiceAllowed', '', true);
    }
    let params: IParamsCollection = {}
    params.filter = FilterBuilder.fromObject(filters).build();
    let contractCapabilityService = await firstValueFrom(this.contractCapabilityService.all(params));
    this.contractCapabilityNotFound = contractCapabilityService.data.length == 0;

    if(tab=='map'){
      //this.updateMap();
    }else{
      //this.onSelectDate();
      this.getAvailability();
    }
  }

  async onSelectDate() {
    this.startWeekDate = moment(this.date).startOf('week').toDate();
    this.endWeekDate = moment(this.date).endOf('week').toDate();

    await this.loadCalendarEvents();
    await this.loadGuardShifts();
    await this.loadCaseServices();
    await this.getAvailability();
  }

  async onSelectDateMap() {
    if(this.startDateMap!=null && this.endDateMap!=null){
      if(this.startDateMap.getTime()>this.endDateMap.getTime()) this.endDateMap = this.startDateMap;
      await this.loadCaseServices();
      await this.loadPendingCases();
      await this.getAvailability();
    }
  }

  async prevDate(){
    this.date = moment(this.date).subtract(1, 'day').toDate();
    if(this.selectSomething) return;
    this.onSelectDate();
  }

  async nextDate(){
    this.date = moment(this.date).add(1, 'day').toDate();
    if(this.selectSomething) return;
    this.onSelectDate();
  }

  async prevWeek(){
    this.date = moment(this.date).subtract(7, 'day').toDate();
    if(this.selectedCapability == null || this.selectedCapability == "" || this.filterByWorkerId == null || this.filterByWorkerId == "") {

      this.startWeekDate = moment(this.date).startOf('week').toDate();
      this.endWeekDate = moment(this.date).endOf('week').toDate();
      return;
    }
    this.onSelectDate();
  }

  async nextWeek(){
    this.date = moment(this.date).add(7, 'day').toDate();
    if(this.selectedCapability == null || this.selectedCapability == "" || this.filterByWorkerId == null || this.filterByWorkerId == "") {
      this.startWeekDate = moment(this.date).startOf('week').toDate();
      this.endWeekDate = moment(this.date).endOf('week').toDate();
      return;
    }
    this.onSelectDate();
  }

  getDateLabel(weekDay:number):string{
    return moment(this.startWeekDate).add(weekDay, 'day').format('dddd');
  }

  getDate(weekDay:number):Date{
    return moment(this.startWeekDate).add(weekDay, 'day').toDate();
  }

  async onIncludeGuardChange(tab: string) {
    this.onSelectCapability(tab); //recargamos las capabilities porque ha seleccionado o no la guardua
    this.generateTimeSlots();
  }

  async loadAllWorkers(){
    let filter:any = {
      active: new Filter(FilterOperation.equals, 'active', '', true)
    };
    let params:IParamsCollection = {
      page: { size: 1000 },
      sort: ['name'],
      include: ['address', 'workStartAddress'],
      fields: { 
        workers: 'id,name,phone1,phone2,manageYourAppointments,latitude,longitude,lastPositionDate,usePrincipalAddressAsWorkStart,addressId,address,workStartAddressId,workStartAddress,calendarId',
        addresses: 'id,latitude,longitude'
      },
      filter: FilterBuilder.fromObject(filter).build()
    };
    let response = await firstValueFrom(this.workersService.all(params));
    this.allWorkers = response.data;

    //calculamos distancias de a salida de operarios respecto a expediente actual
    this.workersDistance = [];
    if(this.case.address!=null && this.case.address.zipCode!=null){
      this.allWorkers.forEach((worker: Worker) => {
        //calculamos distancia desde su punto de partida al servicio referenciado
        if(worker.usePrincipalAddressAsWorkStart){
          this.workersDistance['guid_' + worker.id!] = this.locationUtilsService.distance(worker.address?.latitude!, worker.address?.longitude!, this.case.address?.latitude!, this.case.address?.longitude!, 'K');
        }else if(worker.workStartAddress!=null){
          this.workersDistance['guid_' + worker.id!] = this.locationUtilsService.distance(worker.workStartAddress.latitude!, worker.workStartAddress.longitude!, this.case.address?.latitude!, this.case.address?.longitude!, 'K');
        }
      });
    }

  }

  async getAvailability() {

    let zipCode = this.case.address?.zipCode;
    if(this.service.caseId== null && this.zipCode != "" && this.zipCode != null) zipCode = this.zipCode; //si no hay expediente, usamos el codigo postal seleccionado

    if(this.date == null ||(zipCode == null || zipCode == '')  && 
      (this.selectedCapability == null || this.selectedCapability == '') && 
      (this.selectedVehicleType == null || this.selectedVehicleType == '') && 
      (this.selectedEquipment == null || this.selectedEquipment == '') && this.includeGuardShift == false){
        this.selectSomething = true;
        this.availableWorkers = [];
        this.timeSlots = [];

    }else{
      this.selectSomething = false;

      let response = await firstValueFrom(this.workersService.getAvailability(zipCode, this.selectedCapability, this.selectedVehicleType, this.selectedEquipment, this.includeGuardShift));
      let unsortedWorkers = response;
  
      //obtenemos los workes que son preferentes y los ordenamos por carga
      let preferedWorkers = unsortedWorkers.filter((worker: Worker) => {
        return this.contractPreferedWorkers.find(m => m.workerId == worker.id) != null;
      });
      preferedWorkers.sort((a: Worker, b: Worker) => {
        return (a.workload || 0) - (b.workload || 0);
      });
  
      //obtenemos los workers no preferentes y los ordenamod por carga
      let unpreferedWorkers = unsortedWorkers.filter((worker: Worker) => {
        return this.contractPreferedWorkers.find(m => m.workerId == worker.id) == null;
      });
      unpreferedWorkers.sort((a: Worker, b: Worker) => {
        //return a.name.localeCompare(b.name);
        return (a.workload || 0) - (b.workload || 0);
      });
  
      //generamos array ordenado de operarios disponibles, primero los preferentes
      this.availableWorkers = Array.from(preferedWorkers).concat(unpreferedWorkers);
  
      this.comboWorkers = this.availableWorkers;
  
      //si habia un filtro de operario, dejamos solo el
      if(this.filterByWorkerId!=null){
        this.availableWorkers = this.availableWorkers.filter(m=>m.id == this.filterByWorkerId);
      }
  
      //generamos las marcas de si aceptan normal y guardia en la zona del expediente actual
      if(this.case.address?.zipCode!=null){
        this.workersZonesAvailable = [];
        this.availableWorkers.forEach((worker: Worker) => {
          let normalWorkerZones = this.workerZones.find(m => m.normalServiceAllowed && m.workerId == worker.id && (
            (m.zoneId!=null && this.caseZoneIds.includes(m.zoneId) && (m.excludedZipCodes+',').indexOf(this.case?.address?.zipCode) < 0) || //esta la zona y no esta excluido el codigo postal
            (',' + m.value?.replaceAll(';', ',') + ',').includes(',' + this.case?.address?.zipCode + ',') //esta el codigo manual
          ));
          let guardWorkerZones = this.workerZones.find(m => m.guardServiceAllowed && m.workerId == worker.id && (
            (m.zoneId!=null && this.caseZoneIds.includes(m.zoneId) && (m.excludedZipCodes+',').indexOf(this.case?.address?.zipCode) < 0) || //esta la zona y no esta excluido el codigo postal
            (',' + m.value?.replaceAll(';', ',') + ',').includes(',' + this.case?.address?.zipCode + ',') //esta el codigo manual
          ));
          this.workersZonesAvailable.push({
            id: worker.id,
            workerId: worker.id,
            normalServiceAllowedInCaseZone: normalWorkerZones != null,
            guardServiceAllowedInCaseZone: guardWorkerZones != null
          });
        });
      }
  
      //recargamos los festivos ya con los operarios disponibles conocidos, para
      //limitar la consulta a los calendarios de esos operarios (dentro de un caso)
      await this.loadCalendarEvents();

      //generamos los timeslots necesarios
      this.generateTimeSlots();

      //cargamos eventos de operarios
      this.loadWorkersEvents();
    }
  }

  async loadWorkerZones() {
    let params: IParamsCollection = {
      page: { size: 5000 }
    };
    let response = await firstValueFrom(this.workersZonesService.all(params));
    this.workerZones = response.data;
  }

  async loadServicesTypes(){
    
    let aux = await firstValueFrom(this.caseServiceTypesService.all({ filter: FilterBuilder.fromObject({caseId: new Filter(FilterOperation.equals, 'caseId', '', this.case.id)}).build() }));
    var selectedServiceTypes = aux.data.map(m => m.serviceTypeId);

    let params:IParamsCollection = {
      include: ['serviceType']
    }   
    let filters: any = {
      companyId: new OrFilter([
        new Filter(FilterOperation.equals, 'companyId', '', this.case.companyId),
        new Filter(FilterOperation.equals, 'companyId', '', null, true)
      ]),
      contractId: new OrFilter([
          new Filter(FilterOperation.equals, 'contractId', '', this.case.contractId),
          new Filter(FilterOperation.equals, 'contractId', '', null, true)
      ]),
      serviceTypeId: new Filter(FilterOperation.any, 'id', '', selectedServiceTypes.length > 0 ? selectedServiceTypes : null)
    }; 
    params.filter = FilterBuilder.fromObject(filters).build();
    let response = await firstValueFrom(this.servicesTypesCompanyService.all(params));
    this.servicesTypes = response.data.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i);
    
  }
  
  getAvailableWorkers(): any[] {
    return this.allWorkers.filter((worker: Worker) => {
      return this.comboWorkers.find(m=>m.id == worker.id);
    });
  }

  isWorkerPrefered(worker: Worker): boolean {
    let preferedWorker = this.contractPreferedWorkers.find(m => m.workerId == worker.id);
    return preferedWorker != undefined;
  }

  getTimeSlotDate(date: Date | null, timeSlot: any): moment.Moment {
    return moment(date).set({ hour: timeSlot.hour, minute: timeSlot.minute, second: 0, millisecond: 0 });
  }

  //comprueba si el slot es el primero de la agenda (el que marca la hora de inicio visible)
  isFirstConfirmedTimeSlot(timeSlot: any): boolean {
    if (!timeSlot.confirmed) return false;
    let firstSlot = this.timeSlots.find((slot: any) => slot.confirmed);
    return firstSlot != null && firstSlot.hour == timeSlot.hour && firstSlot.minute == timeSlot.minute;
  }

  //fin de la agenda visible (fin del ultimo slot confirmado) para la fecha indicada
  getAgendaEndDate(date: Date | null): moment.Moment | null {
    let confirmedSlots = this.timeSlots.filter((slot: any) => slot.confirmed);
    if (confirmedSlots.length == 0) return null;
    let lastSlot = confirmedSlots[confirmedSlots.length - 1];
    return this.getTimeSlotDate(date, lastSlot).add(30, 'minute');
  }

  //fin estimado del servicio (si no lo tiene, se asume 1 hora, igual que en el alto del bloque)
  getServiceEstimatedEnd(service: CaseService): moment.Moment {
    if (service.estimatedDateEnd) return moment(service.estimatedDateEnd);
    return moment(service.date).add(1, 'hour');
  }

  /**
   * Un servicio se pinta en el slot en el que empieza. Si empieza antes del inicio de la agenda
   * (por ejemplo un servicio de 4:00 con la agenda de 8:00 a 19:30) se pinta en el primer slot
   * mientras siga ocupandolo, para que no quede oculto.
   */
  isServiceInTimeSlot(service: CaseService, slotStart: moment.Moment, isFirstSlot: boolean): boolean {
    let serviceStart = moment(service.date);
    //empieza dentro del slot
    if (serviceStart.isSameOrAfter(slotStart) && serviceStart.isBefore(moment(slotStart).add(30, 'minute'))) return true;
    //empieza antes del primer slot visible pero ocupa parte de el
    if (!isFirstSlot || !serviceStart.isBefore(slotStart)) return false;
    return this.getServiceEstimatedEnd(service).isAfter(slotStart);
  }

  /**
   * Alto del bloque del servicio en el slot donde se pinta. Un 100% es 30 minutos.
   * Si el servicio empieza antes del slot, se recorta la parte que queda fuera de la agenda.
   */
  getCaseServiceHeight(caseService: CaseService, date: Date | null, timeSlot: any): string {
    let slotStart = this.getTimeSlotDate(date, timeSlot);
    //recortamos lo que quede por encima del slot (empezo antes del inicio de la agenda)
    let start = moment(caseService.date);
    if (start.isBefore(slotStart)) start = slotStart;
    //recortamos lo que quede por debajo del ultimo slot (termina despues del fin de la agenda)
    let end = this.getServiceEstimatedEnd(caseService);
    let agendaEnd = this.getAgendaEndDate(date);
    if (agendaEnd != null && end.isAfter(agendaEnd)) end = agendaEnd;
    let hours = moment.duration(end.diff(start)).asHours();
    if (hours <= 0.5) hours = 0.5;
    return 'calc(' + (hours * 2 * 100) + '% + ' + ((hours * 2)) + 'px)'; //un 100% es 30 minutos, sumamos 2px por cada bloque por el border
  }

  getTimeSlotServices(worker: Worker, timeSlot: any) {
    let slotStart = this.getTimeSlotDate(this.date, timeSlot);
    let isFirstSlot = this.isFirstConfirmedTimeSlot(timeSlot);
    let services = this.casesServices.filter((service: CaseService) => {
      if (service.workerId != worker.id || service.isConfirmed != timeSlot.confirmed) return false;
      //los no confirmados se agrupan todos en el slot de "por confirmar" del dia
      if (!timeSlot.confirmed) {
        return moment(service.date).startOf('day').toISOString() == moment(slotStart).startOf('day').toISOString();
      }
      return this.isServiceInTimeSlot(service, slotStart, isFirstSlot);
    });
    return services;
  }

  hasTimeSlotServices(worker: Worker, timeSlot: any):boolean {
    let services = this.casesServices.filter((service: CaseService) => {
      let isBetween = moment(timeSlot.date).isBetween(moment(service.date), moment(service.estimatedDateEnd));
      return service.workerId == worker?.id && 
        service.isConfirmed == timeSlot.confirmed && 
        (isBetween || moment(timeSlot.date).isSame(moment(service.date)));
    });
    return services.length > 0;
  }

  getDateTimeSlotServices(date: Date, timeSlot: any) {
    let slotStart = this.getTimeSlotDate(date, timeSlot);
    let isFirstSlot = this.isFirstConfirmedTimeSlot(timeSlot);
    let services = this.casesServices.filter((service: CaseService) => {
      //si hay filtro de operario y no es el operario, no se muestra
      if (this.filterByWorkerId != null && service.workerId != this.filterByWorkerId) return false;
      //si no coincide el estado de confirmado, no se muestra
      if (service.isConfirmed != timeSlot.confirmed) return false;
      //los no confirmados se agrupan todos en el slot de "por confirmar" del dia
      if (!timeSlot.confirmed) {
        return moment(service.date).startOf('day').toISOString() == moment(slotStart).startOf('day').toISOString();
      }
      return this.isServiceInTimeSlot(service, slotStart, isFirstSlot);
    });
    return services;
  }

  /*getSelectedTransaction(){
    return this.listAcceptedTransactions.find(m => m.id == this.service.workerBudgetTransactionId);
  }*/

  getWorkerCalendarEvents(worker: Worker, timeSlot: any) {
    let events = this.workerCalendarEvents.filter((event: WorkerCalendarEvent) => {
      let show = false;
      //si es del operario
      if (event.workerId == worker.id) {
        if (!event.calendarEventType.allowTimeRange) {
          //si es un evento de todo el dia
          show = true;
        } else {
          //comprobamos si la hora esta comprendida en el rango
          let startparts = event.start.split(':');
          let endparts = event.end.split(':');
          let startDate = moment(event.date).set({ hour: startparts[0], minute: startparts[1] });
          let endDate = moment(event.date).set({ hour: endparts[0], minute: endparts[1] });
          let timeSlotDate = moment(event.date).set({ hour: timeSlot.hour, minute: timeSlot.minute });
          show = moment(timeSlotDate).isBetween(startDate, endDate, undefined, '[)');
        }
      }
      return show;
    });
    return events;
  }

  getDateCalendarEvents(date: Date, timeSlot: any) {

    let events = this.workerCalendarEvents.filter((event: WorkerCalendarEvent) => {

      let dateFormat = moment(event.date.toISOString()).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      let startDate = moment(date.toISOString()).set({ hour: 0, minute: 0, second: 0, millisecond: 0});
      let show = false;
      //si es de la fecha en cuestion
      //if (event.date.toISOString() == date.toISOString()) {
        if(dateFormat.toISOString() == startDate.toISOString())
        {
          //si es del operario elegido o no hay filtro
          if(this.filterByWorkerId==null || event.workerId == this.filterByWorkerId){
  
            if (!event.calendarEventType.allowTimeRange) {
              //si es un evento de todo el dia
              show = true;
            } else {
              //comprobamos si la hora esta comprendida en el rango
              let startparts = event.start.split(':');
              let endparts = event.end.split(':');
              let startDate = moment(event.date).set({ hour: startparts[0], minute: startparts[1] });
              let endDate = moment(event.date).set({ hour: endparts[0], minute: endparts[1] });
              let timeSlotDate = moment(event.date).set({ hour: timeSlot.hour, minute: timeSlot.minute });
              //show = moment(timeSlotDate).isBetween(startDate, endDate);
              show = moment(timeSlotDate).isBetween(startDate, endDate, undefined, '[)');            
            }
          }
        }
     // }
      return show;
    });
    return events;
  }

  /** Nombres de los materiales a retirar de una cita, separados por coma. Vacio si no tiene. */
  materialNamesOf(caseService: CaseService | null): string {
    return (caseService?.materials ?? [])
      .filter((relation: any) => !!relation?.material)
      .map((relation: any) => relation.material.name)
      .join(', ');
  }

  setOverCaseService(caseService: CaseService) {
    this.overCaseService = caseService;
  }

  clearWorkerTimeSlot() {
    this.selectedWorker = null;
    this.selectedTimeSlot = null;
    this.service.workerId = null;
    this.caseServiceFormGroup.patchValue(this.service);
  }

  selectWorkerTimeSlot(worker: Worker, timeSlot: any) {
    if(this.case.id==null || this.case.id=='') return;
    let caseServicesSlot = this.getTimeSlotServices(worker, timeSlot);
    if (( caseServicesSlot.length == 0) || !timeSlot.confirmed) {
      this.isNotAllowed = !this.isWorkerSlotAllowed(worker, timeSlot);
      if(this.isNotAllowed){ this.showCheckIfIsGuard = true; }else{ this.showCheckIfIsGuard = false; }
     
      this.openCreateServiceDialog(worker, timeSlot);
    }
  }

  selectDateTimeSlot(date: Date, timeSlot: any) {
    if(this.case.id==null || this.case.id=='') return;
    let worker = this.availableWorkers.find(m=>m.id == this.filterByWorkerId);
    if(worker==null) return;
    let caseServicesSlot = this.getTimeSlotServices(worker, timeSlot);
    if (caseServicesSlot.length == 0 || !timeSlot.confirmed) {
      //si esta permitido el slot
      if(this.isWorkerSlotAllowed(worker, timeSlot)){
        this.openCreateServiceDialog(worker, timeSlot, date);
      }
    }
  }

  getFilteredWorker(){
    if(this.filterByWorkerId!=null){
      return this.allWorkers.find(m=>m.id == this.filterByWorkerId);
    }
    return null;
  }

  async openCreateServiceDialog(worker: Worker, timeSlot: any, date:Date|null = null) {

    //si no hay seleccionado especialidad no dejamos crear servicio.
    if(this.selectedCapability){
          
      this.minDate = new Date();
      this.selectedWorker = worker;
      this.selectedTimeSlot = timeSlot;
      this.service.notes = this.config?.data.notes ?? '';
      this.service.economicNotes = '';
      this.service.notModify = false;
      this.service.workerId = worker.id!;
      this.service.isUrgent = this.service.isUrgent;
      //this.service.isGuard = timeSlot.guard;
      //marcar guardia si está elegido el horairo de guardia
      this.service.isGuard = this.includeGuardShift;
      this.service.isConfirmed = !worker.manageYourAppointments;
      this.service.isValidated = false;
      this.service.workerBudgetTransactionId = null;
      let serviceDate = date??this.date;
      if (timeSlot.confirmed && !worker.manageYourAppointments) {
        this.service.date = moment(serviceDate).set({ hour: timeSlot.hour, minute: timeSlot.minute, second: 0 }).toDate();
      } else {
        this.service.date = moment(serviceDate).startOf('day').toDate();
      }
      this.hoursPredefinedCaseService = this.service.isGuard ? 1 : worker.hoursCaseService;

      //comprobamos si hay un servicio anterior a más de 10 km
      let tooLongDistance = false;
      let previousServices = this.casesServices.filter(m=>m.workerId == worker.id && m.date < this.service.date).sort((a, b) => a.date.getTime() - b.date.getTime()).reverse();
      if(previousServices.length>0){
        //comprobamos si esta a mas de 10km
        let previousService = previousServices[0];
        let distance = this.locationUtilsService.distance(previousService.case?.address.latitude!, previousService.case?.address.longitude!, this.case?.address.latitude!, this.case?.address.longitude!, 'K');
        if(distance!=null && distance>10){
          tooLongDistance = true;
        }
      }else{
        //si la distancia es desde la salida del operario, no avisamos
        /*let workerStartDistance = this.workersDistance['guid_' + worker.id!];
        if(workerStartDistance!=null && workerStartDistance>10){
          tooLongDistance = true;
        }*/
      }
      if(this.service.date!=null) this.dateInitChanged(this.service.date);
      this.service.capabilityId = this.selectedCapability!;
      this.caseServiceFormGroup.patchValue(this.service);
      this.service.estimatedDateEnd = moment(this.service.date).add(this.hoursPredefinedCaseService, 'hour').toDate();
      await this.loadAcceptedBudget();
  
      //si hay un servicio anterior a más de 10 km, lo mostramos
      if(tooLongDistance){
        this.confirmationService.confirm({
            message: 'El servicio está a más de 10 km de distancia del último servicio realizado por el operario. ¿Desea continua de todos modos?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Continuar',
            rejectLabel: 'Cancelar',
            accept: () => {
                this.createServiceDialogVisible = true;
              this.createServiceDialogVisible = true;
              this.scheduleResizeTextareas();
            },
            reject: () => {
                this.createServiceDialogVisible = false;
            }
        });
      }else{
        this.createServiceDialogVisible = true;
        this.createServiceDialogVisible = true;
        this.scheduleResizeTextareas();
      }
    }else{
         this.messageService.add({ closable: true, severity: 'error', detail: "No se ha seleccionado la especialidad" });
        return;
    }
  }

  eventClicked(event: any, eventCalendar: WorkerCalendarEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  serviceClicked(event: any, service: CaseService) {
    this.editCaseService(service);
    event.preventDefault();
    event.stopPropagation();
  }

  isWorkerSlotGuard(worker: Worker|null|undefined, timeSlot: any, weekDay:number = 0): boolean {
    if(!worker) return false;
    if (!this.includeGuardShift) return false;
    
    //calculamos la fecha para el slot
    let slotDate = moment(timeSlot.date).toDate();
    if(this.activeIndex==1){
      //si estamos en vista semanal, la fecha del slot es la del dia de la semana, no la del dia seleccionado
      slotDate = moment(this.startWeekDate).add(weekDay, 'day').toDate();
    }

    let isGuard: boolean = false;
    let hour = timeSlot.label + ":00";
    hour = hour.padStart(8, '0');
    if (worker.workerGuardShifts != null && this.includeGuardShift) {
      for(let workerGuardShift of worker.workerGuardShifts){
        let guardShift = this.guardShifts.find(m => m.id == workerGuardShift.guardShiftId);
        if (guardShift != null) {
          let startHour = guardShift.startHour;
          let endHour = guardShift.endHour;

          //si es festivo, usamos la configuracion de festivo
          let isHoliday = this.calendarEvents.filter((event: CalendarEvent) => {
            return moment(event.date).isSame(slotDate, 'day') && event.calendarId == worker.calendarId;
          }).length > 0;
          if (isHoliday) {
            startHour = guardShift.startHourHoliday;
            endHour = guardShift.endHourHoliday;
          }

          //si es fin de samana, usamos la configuracion del fin de semana
          let day = moment(slotDate).day();
          let isWeekend = (day == 0 || day == 6);
          if(isWeekend){
            startHour = guardShift.startHourWeekend;
            endHour = guardShift.endHourWeekend;
          }

          
          if (startHour < endHour) {
            //mismo dia
            isGuard = startHour < hour && endHour >= hour;
          } else {
            //termina al dia siguiente
            isGuard = (startHour <= hour && "23:59:59" > hour) || ("00:00:00" <= hour && endHour > hour);
          }
        }
        if(isGuard) break;
      }
    }
    return isGuard;
  }

  isWorkerSlotAllowed(worker: Worker|null|undefined, timeSlot: any, weekDay: number = 0): boolean {
    this.isNotAllowedReason = '';
    if(!worker) return false;

    //calculamos la fecha para el slot
    let slotDate = moment(timeSlot.date).toDate();
    if(this.activeIndex==1){
      //si estamos en vista semanal, la fecha del slot es la del dia de la semana, no la del dia seleccionado
      slotDate = moment(this.startWeekDate).add(weekDay, 'day').toDate();
    }

    //comprobamos si la hora esta disponible para el worker
    let hour = timeSlot.label + ":00";
    hour = hour.padStart(8, '0');
    let day = moment(slotDate).day();

    //si es una slot normal
    let allowed: boolean = false;
    
    let validTimeRanges = this.workerTimeRanges.filter((range: WorkerTimeRange) =>
      range.workerId == worker.id &&
      (
        (day == 1 && range.monday) ||
        (day == 2 && range.tuesday) ||
        (day == 3 && range.wednesday) ||
        (day == 4 && range.thursday) ||
        (day == 5 && range.friday) ||
        (day == 6 && range.saturday) ||
        (day == 0 && range.sunday)
      )
      &&
      (
        (range.startHour <= hour && range.endHour > hour)
        ||
        (!timeSlot.confirmed && worker.manageYourAppointments)
      )
    );
    allowed = validTimeRanges.length > 0;
    //si incluijos horario de guardia, lo revisamos tambien
    if (!allowed && this.includeGuardShift) {
      //si es guardia, comprobamos su turno de guardia
      allowed = this.isWorkerSlotGuard(worker, timeSlot, weekDay);
    }
    //si esta permitido, verificamos tambien que tiene habilitada la zona del expediente actual
    if (allowed) {
      let workerZone = this.workersZonesAvailable.find(m => m.workerId == worker.id);
      let isGuard = this.isWorkerSlotGuard(worker, timeSlot, weekDay);
      if (workerZone != null) {
        if (isGuard) {
          allowed = workerZone.guardServiceAllowedInCaseZone;
        } else {
          allowed = workerZone.normalServiceAllowedInCaseZone;
          if(!allowed){
            this.isNotAllowedReason = 'worker-time';
          }
        }
      } else if(this.case!=null && this.case.id!=null && this.case.id!='') {
        allowed = false;
        this.isNotAllowedReason = 'worker-zone';
      }

      //el festivo del calendario del operario bloquea el servicio normal con
      //independencia de la zona/expediente (tambien en el planificador sin caso)
      if(allowed && !isGuard){
        let calendarEvent = this.calendarEvents.filter(m=>m.calendarId == worker.calendarId && moment(m.date).isSame(moment(slotDate), 'day'));
        if(calendarEvent.length>0){
          allowed = false;
          this.isNotAllowedReason = 'worker-calendar-event';
        }
      }
    }else{
        this.isNotAllowedReason = 'worker-time';
    }

    return allowed;
  }

  async editCaseService(caseService: CaseService) {
    let ref = this.dialogService.open(CaseServiceDetailComponent, {
      closable: true,
      modal: true,
      header: 'Ficha de servicio',
      width: '80%',
      data: {
        caseId: caseService.caseId,
        caseServiceId: caseService ? caseService.id : null,
        showLilnkCase: true
      }
    });

    ref.onClose.subscribe(() => {
      this.loadCaseServices();
    });
  }

  cancel() {
    if(this.dynamicDialogRef) this.dynamicDialogRef.close();
  }

  async getCaseServicesBettenDates(worker: Worker, startDate: Date, endDate: Date): Promise<CaseService[]> {
    let filters: any = {
      workerId: new Filter(FilterOperation.equals, 'workerId', '', worker.id),
      date1: new Filter(FilterOperation.greaterThan, 'date', '', startDate.toISOString()),
      date2: new Filter(FilterOperation.lessThan, 'date', '', endDate.toISOString()),
    };
    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build()
    }
    var response = await firstValueFrom(this.casesServicesService.all(params));
    return response.data;
  }


  async preSave() {

    //comprobamos si la fecha de inicio es superior a la fecha de fin
    if (this.service.date > this.service.estimatedDateEnd) {
      this.messageService.add({ closable: true, severity: 'error', detail: "La fecha de fin debe ser superior a la fecha de inicio." });
      return;
    }

    //notas minimas de 25 caracteres
    if (this.service.notes == null || this.service.notes.trim().length < 25) {
      this.messageService.add({ closable: true, severity: 'error', detail: "Las notas deben tener al menos 25 caracteres." });
      return;
    }

    //notas máximas de 2000 cara  cteres
    if(this.service.notes.length > 2000){
      this.messageService.add({ closable: true, severity: 'error', detail: "Las notas no deben exceder los 2000 caracteres." });
      return;
    }

    //comprobamos si 
     if(this.caseNotificationNumbers.length > 0 && this.service.caseNotificationNumberId == null){
      this.messageService.add({ closable: true, severity: 'error', detail: "El número de servicio relacionado es obligatorio." });
      return;
    }

    this.caseService = new CaseService();
    delete this.caseService.id;
    this.caseService.date = this.service.date;
    this.caseService.capabilityId = this.selectedCapability!;
    if(this.selectedEquipment!=null && this.selectedEquipment!='') this.caseService.equipmentId = this.selectedEquipment;
    //el backend replica estos materiales en cada cita generada (una por dia si la cita abarca varios)
    this.caseService.materials = this.selectedMaterials.map((materialId: string) => {
      let relation = new CaseServiceMaterial();
      delete relation.id;
      relation.materialId = materialId;
      return relation;
    });
    this.caseService.workerId = this.selectedWorker!.id!;
    this.caseService.caseId = this.service.caseId;
    this.caseService.estimatedDateEnd = this.service.estimatedDateEnd;
    this.caseService.notes = this.service.notes;
    this.caseService.economicNotes = this.service.economicNotes;
    this.caseService.notModify = this.service.notModify;
    this.caseService.isUrgent = this.service.isUrgent;
    this.caseService.isGuard = this.service.isGuard;
    this.caseService.isValidated = false;
    this.caseService.isConfirmed = this.service.isConfirmed;
    this.caseService.workerBudgetTransactionId = this.service.workerBudgetTransactionId;
    this.caseService.isBudgetRequired = this.service.isBudgetRequired;
    this.caseService.isNotScheduled = this.service.isNotScheduled;
    this.caseService.reclamationType = this.service.reclamationType;
    this.caseService.caseNotificationNumberId = this.service.caseNotificationNumberId;

    let selectedTarget = this.targets.find(target => target.id === this.targetId);

    if (selectedTarget.type == "clients") {
      this.caseService.clientId = selectedTarget.id;
      this.caseService.clientAddressId = selectedTarget.addressId;
      this.caseService.affectedId = null;
      this.caseService.affectedAddressId = null;
      this.caseService.target = "Client";
    } else {
      this.caseService.clientId = null;
      this.caseService.affectedId = selectedTarget.id;
      this.caseService.affectedAddressId = selectedTarget.addressId;
      this.caseService.clientAddressId = null;
      this.caseService.target = "Affected";
    }

    //Comprobamos si han pasado las horas minimas
    if (this.isFirstService) {
      let capability = this.capabilities.find(m => m.id == this.selectedCapability);
      let maxHours = (this.service.isUrgent ? capability?.serviceUrgentHours : capability?.serviceNormalHours) ?? 0;
      let hours = moment.duration(moment(this.caseService.date).diff(moment(this.case.caseDate))).asHours();
      if (maxHours > 0 && hours > maxHours) {
        let detail = this.service.isUrgent
          ? "El servicio no cumple con el tiempo máximo configurado para tratar una urgencia. El tiempo máximo es de " + maxHours + " horas desde la apertura del expediente."
          : "El servicio no cumple con el tiempo máximo configurado. El tiempo máximo es de " + maxHours + " horas desde la apertura del expediente.";
        this.messageService.add({ closable: true, severity: 'error', detail: detail });
        this.showDelayedServiceModal = true;
        await this.loadDelayedCaseServiceCauses();
      } else {
        this.save(this.caseService);
      }
    } else {
      this.save(this.caseService);
    }

  }

  
  async loadDelayedCaseServiceCauses() {
    //Cargamos los estados finales
    let params: IParamsCollection = {}
    let filters = {
      caseServiceCauseType: new Filter(FilterOperation.equals, 'caseServiceCauseType', '', 'DelayedDate')
    }
    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.casesServicesCausesService.all(params));
    this.delayedServiceCauses = response.data;
    this.delayedServiceCauses.push({ id: -1, name: "Otros" });

  }

  onReclamationTypeChange(){
    if(this.service.reclamationType != null){
      this.service.notModify = true;
    }
  }

  async loadDelayedReasons($event: any) {
    /*let params: IParamsCollection = {}
    let filters = {
      caseServiceReasonType: new Filter(FilterOperation.equals, 'caseServiceReasonType', '', 'DelayedDate')
    }
    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();
*/


    //si es otro, no hacemos nada
    this.caseService.cancelCaseServiceReasonNotes = '';
    if($event.value == null || $event.value == -1) {
      this.caseService.cancelCaseServiceCauseId = null;
      this.caseService.cancelCaseServiceReasonNotes = null;
    }else{
      let params: IParamsCollection = {}
      let filters = {
        caseServiceCauseId: new Filter(FilterOperation.equals, 'caseServiceCauseId', '', $event.value),
        caseServiceReasonType: new Filter(FilterOperation.equals, 'caseServiceReasonType', '', 'DelayedDate')
      }
      params.filter = FilterBuilder.fromObject(filters).build();
    let response = await firstValueFrom(this.casesServicesReasonsService.all(params));
      this.delayedServiceReasons = response.data;
      this.delayedServiceReasons.push({ id: -1, name: "Otros" });


    }


  }

  cancelDelayedCaseModal() {
    this.showDelayedServiceModal = false;
  }


  async save(caseService: any) {

    //notas minimas de 25 caracteres    
    if (caseService.delayedCaseServiceReasonId == '-1' && (typeof caseService.delayedCaseServiceReasonNotes == "undefined" || caseService.delayedCaseServiceReasonNotes == null || caseService.delayedCaseServiceReasonNotes.trim().length < 25)) {
      this.messageService.add({ closable: true, severity: 'error', detail: "Las notas deben tener al menos 25 caracteres." });
      return;
    } else {
      if (caseService.delayedCaseServiceReasonId == '-1') {
        caseService.delayedCaseServiceReasonId = null;
      } else {
        caseService.delayedCaseServiceReasonNotes = null;
      }

      let response = await firstValueFrom(this.casesServicesService.create(caseService));
      if(this.dynamicDialogRef) this.dynamicDialogRef.close(response);
      this.showDelayedServiceModal = false;    
      this.createServiceDialogVisible = false;      
      this.selectedMaterials = [];
      this.loadCaseServices();

      //cerramos ventana de info de marker por si estuviese abierta
      this.closeInfoWindow();

      //si estamos eligiendo caso, lo limpiamos
      if(this.showCaseSelector){
        this.case = new Case();
      }
    }
  }

  markAsAllowedService(){
    this.isNotAllowed = false;
  }

  markAsConfirmed(){
    this.service.isConfirmed = true;
    let serviceDate = this.selectedTimeSlot.date;
    this.service.date = moment(serviceDate).set({ hour: this.selectedTimeSlot.hour, minute: this.selectedTimeSlot.minute, seconds: 0 }).toDate();
    this.service.estimatedDateEnd = moment(this.service.date).add(this.hoursPredefinedCaseService, 'hour').toDate();
    this.dateInitChanged(this.service.date);
  }

  serviceHasHours():boolean {
    return this.service.dateStart.getTime() != (new Date()).getTime();
  }

  async closeServiceDialog(){
    this.createServiceDialogVisible=false;
    this.selectedMaterials = [];

    //si estamos eligiendo caso, lo limpiamos
    if(this.showCaseSelector){
      this.case = new Case();
    }
  }

  public scheduleResizeTextareas(): void {
    setTimeout(() => this.resizeAllTextareas(), 0);
  }

  private resizeAllTextareas(maxHeight: number = 320): void {
    if (!this.autoGrowTextareas) {
      return;
    }

    this.autoGrowTextareas.forEach((textareaRef) => {
      this.stringUtilsService.ResizeTextareaElement(textareaRef.nativeElement, maxHeight);
    });
  }

  async deleteCaseService(caseService: CaseService) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el servicio?",
      header: "Eliminar trabajo",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.casesServicesService.delete(caseService.id!).subscribe({
          next: () => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Servicio eliminado correctamente." });
            this.loadCaseServices();
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: () => {
      }
    });
  }

  async printVisitReport(caseService: CaseService) {
    this.casesServicesService.printVisitReport(caseService.id!);
  }

  async goToCase(caseService: CaseService) {
    window.open("/cases/" + caseService.caseId, "_blank");
  }


  dateInitChanged(newDate: Date) {

    //comprobamos que la fecha de inicio sea superior a la actual + 5 minutos
    this.invalidDates = false;
    if ((this.service.isConfirmed && moment(newDate).isBefore(moment().add(5, 'minutes'))) || (!this.service.isConfirmed && moment(newDate).isBefore(moment().startOf('day')))) {
      this.invalidDates = true;
    }

    //calculamos la fecha de fin como las horas predefinidas por el trabajador
    this.service.estimatedDateEnd = moment(newDate).add(this.hoursPredefinedCaseService, 'hours').toDate();
  }
  
    addComunication(comunicationType:string|null, email:string|null, phoneNumber:string|null, attachment: boolean = false) {
      let ref = this.dialogService.open(ComunicationsComponent, {
        closable: true,
        modal: true,
        header: 'Enviar comunicación',
        width: '60%',
        data: {
          caseId: this.phoneOverlayPanelData.case?.id,
          model: this.phoneOverlayPanelData.case,
          comunicationType: comunicationType,
          email: email,
          phoneNumber: phoneNumber,
          attachments: []
        }
      });
  
      ref.onClose.subscribe((data: any) => {
        
      });
    }

    showPhoneOverlayPanel($event:any, phoneNumber:string|undefined, callerId: string|undefined, item:Case|null){
      this.phoneOverlayPanelData.phoneNumber = phoneNumber;
      this.phoneOverlayPanelData.callerId = callerId;
      this.phoneOverlayPanelData.case = item;
      this.phoneOverlayPanel?.show($event);
    }
  
    mail(email:string|undefined, caseId:string|null = null, caseServiceId:string|null = null, attachment: boolean = false){
      if(email){
       this.addComunication('Mail', email, null, attachment);
      }
    }
  
    sms(phoneNumber:string|undefined, caseId:string|null = null, caseServiceId:string|null = null){
      if(phoneNumber){
       this.addComunication('SMS', null, phoneNumber);
      }
    }
  
    call(phoneNumber:string|undefined, callerId:string|null = null, caseId:string|null = null, caseServiceId:string|null = null){
       if(phoneNumber){
        this.phoneService.call(phoneNumber!, callerId, true, caseId, caseServiceId);
       }
    }

    getDateAgo(date:Date):string{
      return moment(date).fromNow();
    }

    getTimeSlotForMarker(markerData:any){

      //obtenemos el worker
      let worker:Worker|undefined = this.getWorkerFromMarker(markerData);

      //obtenemos la fecha
      let date:Date = this.getDateFromMarker(markerData);

      //generamos los time slots
      let timeSlots = [];
  
      //timeslot para por confirmar
      if(worker?.manageYourAppointments){
        timeSlots.push({
          label: 'Por confirmar',
          confirmed: false,
          guard: false,
          date: moment(date).startOf('day').toDate(),
          hour: 0,
          minute: 0
        });
      }
  
      //all time slot
      let allHourStart = 0;
      let allHourEnd = 23;
  
      //horario normal
      let normalHourStart = 8;
      let normalHourEnd = 19;
  
      //geenramos slots
      let hourStart = normalHourStart;
      let hourEnd = normalHourEnd;
      if (this.includeGuardShift) {
        hourStart = allHourStart;
        hourEnd = allHourEnd;
      }
      for (let i = hourStart; i <= hourEnd; i++) {
        let guard = i < normalHourStart || i >= normalHourEnd;

        //slot de hora completa
        let timeSlot = {
          label: i + ':00',
          confirmed: true,
          guard: guard,
          date: moment(date).set({ hour: i, minute: 0 }).toDate(),
          hour: i,
          minute: 0,
          hasServices: false
        };
        timeSlot.hasServices = this.hasTimeSlotServices(worker!, timeSlot);
        timeSlots.push(timeSlot);

        //slot de media hora
        timeSlot = {
          label: i + ':30',
          confirmed: true,
          guard: guard,
          date: moment(date).set({ hour: i, minute: 30 }).toDate(),
          hour: i,
          minute: 30,
          hasServices: false
        };
        timeSlot.hasServices = this.hasTimeSlotServices(worker!, timeSlot);
        timeSlots.push(timeSlot);
      }
      return timeSlots;
    }

    getWorkerFromMarker(markerData:any):Worker|undefined{
      let workerId = '';
      let date = this.startDateMap;
      if(markerData.service!=null){
        workerId = markerData.service.workerId;
        date = markerData.service.date;
      }else if(markerData.worker!=null){
        workerId = markerData.worker.id;
      }
      return this.allWorkers.find(m=>m.id == workerId);
    }

    getDateFromMarker(markerData:any):Date {
      let date = this.startDateMap;
      if(markerData.service!=null){
        date = markerData.service.date;
      }
      return date;
    }

    getServicesForMarker(markerData:any){
      let worker:Worker|undefined = this.getWorkerFromMarker(markerData);
      let date:Date = this.getDateFromMarker(markerData);
      let services = this.casesServices.filter(m=>
        m.workerId == worker?.id &&
        moment(m.date).startOf('day').toISOString() == moment(date).startOf('day').toISOString()
      );
      return services;
    }

    async createServiceForMarker(markerData:any, timeSlot:any){
      if(this.selectedCapability==null || this.selectedCapability==''){
        this.messageService.add({ closable: true, severity: 'error', detail: "No se ha seleccionado la especialidad" });
        return;
      }

      let worker:Worker|undefined = this.getWorkerFromMarker(markerData);
      this.minDate = new Date();
      this.selectedWorker = worker!;
      this.selectedTimeSlot = timeSlot;
      this.service.notes = this.config?.data.notes ?? '';
      this.service.economicNotes = '';
      this.service.notModify = false;
      this.service.workerId = this.selectedWorker?.id!;
      this.service.isUrgent = this.service.isUrgent;
      this.service.isGuard = timeSlot.guard;
      this.service.isConfirmed = !this.selectedWorker?.manageYourAppointments;
      this.service.isValidated = false;
      this.service.workerBudgetTransactionId = null;
      let serviceDate = timeSlot.date;
      if (timeSlot.confirmed && !this.selectedWorker?.manageYourAppointments) {
        this.service.date = moment(serviceDate).set({ hour: timeSlot.hour, minute: timeSlot.minute }).toDate();
      } else {
        this.service.date = moment(serviceDate).startOf('day').toDate();
      }
      this.service.capabilityId = this.selectedCapability!;
      this.service.equipmentId = this.selectedEquipment;
      this.caseServiceFormGroup.patchValue(this.service);
      this.hoursPredefinedCaseService = this.service.isGuard ? 1 : (this.selectedWorker?.hoursCaseService ?? 2); //default 2 hours
      this.service.estimatedDateEnd = moment(this.service.date).add(this.hoursPredefinedCaseService, 'hour').toDate();
      await this.loadAcceptedBudget();
      this.createServiceDialogVisible = true;
    }

    calculateRoute(marker:MapMarker | null){
      this.directionsResults = undefined;
      if(this.case.address.latitude==null || this.case.address.longitude==null){
        this.messageService.add({ closable: true, severity: 'error', detail: "No se ha podido calcular la ruta, no hay coordenadas del expediente." });
        return;
      }
      if(marker==null || marker.getPosition()==null){
        this.messageService.add({ closable: true, severity: 'error', detail: "No se ha podido calcular la ruta, no hay coordenadas del marcador." });
        return;
      }
      const request: google.maps.DirectionsRequest = {
        destination: { lat: this.case.address.latitude!, lng: this.case.address.longitude! }, //el expediente
        origin: { lat: marker.getPosition()?.lat()!, lng: marker.getPosition()?.lng()! }, //el marker clicado
        travelMode: google.maps.TravelMode.DRIVING
      };
      this.mapDirectionsService.route(request).subscribe(
        (response: MapDirectionsResponse) => {
          if (response.status === google.maps.DirectionsStatus.OK) {
            this.directionsResults = response.result;
            this.messageService.add({ closable: true, severity: 'success', detail: "Ruta calculada" });
          } else {
            this.messageService.add({ closable: true, severity: 'error', detail: "Error al calcular la ruta" });
          }
        },
        (error: any) => {
          console.error('Error fetching directions', error);
        }
      )
    }

    async calculateRouteWorker(worker:Worker){
      this.directionsResults = undefined;

      //vaciamos ruta anterior
      this.routeStartAddress = null;
      this.routeCaseServices = [];

      //buscamos la direccion de salida
      let startAddressId = worker.usePrincipalAddressAsWorkStart ? worker.addressId : worker.workStartAddressId;
      if(startAddressId==null){
        this.messageService.add({ closable: true, severity: 'error', detail: "No se ha podido calcular la ruta, no se encontro la dirección de salida del operario." });
        return;
      }
      let startAddress = await firstValueFrom(this.addressesService.get(startAddressId));
      if(startAddress==null || startAddress.latitude==null || startAddress.longitude==null){
        this.messageService.add({ closable: true, severity: 'error', detail: "No se ha podido calcular la ruta, no hay coordenadas de salida del operario." });
        return;
      }
      let origin = new google.maps.LatLng(startAddress?.latitude!, startAddress?.longitude!);
      
      //buscamos todos los servicios del operario ordenados por fecha y hora
      let workerServices = this.casesServices.filter(m=>m.workerId == worker.id);
      if(workerServices.length==0){
        this.messageService.add({ closable: true, severity: 'error', detail: "No hay servicios asignados al operario para calcular la ruta." });
        return;
      }

      //los ordenamos por fecha
      workerServices = workerServices.sort((a:CaseService, b:CaseService) => {
        return moment(a.date).diff(moment(b.date));
      });

      //cogemos solo los del primer dia de trabajo
      let firstDate = moment(workerServices[0].date).startOf('day').toISOString();
      workerServices = workerServices.filter(m=>moment(m.date).startOf('day').toISOString() == firstDate);

      //preaparamos los waypoints de la ruta
      let waypoints: google.maps.DirectionsWaypoint[] = [];
      workerServices.forEach((service: CaseService) => {
        if(service.case?.address!=null && service.case?.address.latitude!=null && service.case?.address.longitude!=null){
          waypoints.push({
            location: new google.maps.LatLng(service.case?.address.latitude!, service.case?.address.longitude!),
            stopover: false
          });
        }
      });

      //usamos ultimo waypoint como destino
      let destination = waypoints.pop()?.location as google.maps.LatLng;

      //calculamos el itinerario
      const request: google.maps.DirectionsRequest = {
        destination: destination, //el expediente
        origin: origin, //el marker clicado
        waypoints: waypoints,
        optimizeWaypoints: false,
        travelMode: google.maps.TravelMode.DRIVING
      };
      this.mapDirectionsService.route(request).subscribe(
        (response: MapDirectionsResponse) => {
          if (response.status === google.maps.DirectionsStatus.OK) {
            this.directionsResults = response.result;
            this.routeStartAddress = startAddress;
            this.routeCaseServices = workerServices;
            this.messageService.add({ closable: true, severity: 'success', detail: "Itinerario calculado" });
          } else {
            this.messageService.add({ closable: true, severity: 'error', detail: "Error al calcular la itinerario" });
          }
        },
        (error: any) => {
          console.error('Error fetching directions', error);
        }
      )
    }

    async loadPendingCases(){
      this.pendingCases = [];
      //cargamos los expedientes pendientes de citar
      let filter:any = {
        caseStateId: new Filter(FilterOperation.equals, 'caseStateId', '', this.selectedCaseStateId),
        dateStart: new Filter(FilterOperation.greaterOrEqual, 'caseDate', '', moment(this.startDateMap).startOf('day').toISOString()),
        dateEnd: new Filter(FilterOperation.lessOrEqual, 'caseDate', '', moment(this.endDateMap).endOf('day').toISOString())
      };
      if(this.onlyUrgentCases) filter.isUrgent = new Filter(FilterOperation.equals, 'isUrgent', '', true);
      let params: IParamsCollection = {
        filter: FilterBuilder.fromObject(filter).build(),
        include: ['address', 'client'],
        page: {size: 500}
      };
      let response = await firstValueFrom(this.casesService.all(params));
      this.pendingCases = response.data;
    }

    async onCasesSearchFilter($event:any){
      if(this.onCasesSearchFilterTimeout) clearTimeout(this.onCasesSearchFilterTimeout);
      this.onCasesSearchFilterTimeout = setTimeout(async () => {
        await this.loadCases($event);
      }, 500);
    }

    async loadCases(event:any) {   
      this.cases = [];
      if (event != null){
        let text = '';
        text = event.filter; 
        if(text!=null && text.length > 0){
          let filters = {name: new Filter(FilterOperation.contains, 'caseNumber', '', text)};  
          let params: IParamsCollection = {
            filter: FilterBuilder.fromObject(filters).build(),
            include: ['address', 'client'],
            fields: {
              cases: ['caseNumber', 'description', 'displayName'],
              addresses: ['fullAddress'],
              clients: ['name']
            },
            page: {size: 500}
          };
          let response = await firstValueFrom(this.casesService.all(params));
          this.cases = response.data;
        }
      }
    }

    trackByIndex(index: number, item: any): number {
      return index;
    }

    countLength(event: any) {
      if(this.service.notes.length > 2000){
        this.showMessageNotes = true;
      }else{
        this.showMessageNotes = false;
      }

    }



}
